export const SET_SUBVENTIONS_STATI = "setSubventionsStati";
export const SET_SUBVENTIONS_KANTONE = "setSubventionsKantone";
export const SET_AUSBILDUNG_STATI = "setAusbildungStati";
export const SET_ABSCHLUESSE = "setAbschluesse";
export const SET_AUSBILDUNGEN = "setAusbildungen";
